import React, {useMemo} from "react";
import {Col, Row} from "reactstrap";
import {InputForm} from "../../base/input/input";
import {DatePickerForm} from "../../base/date-picker";
import Button from "../../base/button/button";
import Form from "../../base/form";
import {MuiRFF, Yup} from '../../form';
import DateUtils from "../../../../core/services/date-utils";
import ValidateMessages from "../../../../core/models/static/texts/vallidate-messages";

const formKeys = {
    keyword: 'keyword',
    startDate: 'startDate',
    endDate: 'endDate',
}

const schema = Yup.object().shape({
    [formKeys.keyword]: Yup.string().nullable(),
    [formKeys.startDate]: Yup.mixed()
        .validDate(ValidateMessages.incorrect)
        .maxDate(Yup.ref(formKeys.endDate), ValidateMessages.lessThan('End Date'))
        .disableFutureDate(ValidateMessages.maxDate("today"), 'day')
        .nullable(),
    [formKeys.endDate]: Yup.mixed()
        .validDate(ValidateMessages.incorrect)
        .minDate(Yup.ref(formKeys.startDate), ValidateMessages.greaterThan('Start Date'))
        .disableFutureDate(ValidateMessages.maxDate("today"), 'day')
        .nullable(),
});

const validate = MuiRFF.makeValidate(schema);
const required = MuiRFF.makeRequired(schema);

const PromotionsListSearchSection = ({filters, setFilters}) => {

    /**
     * Memo version of the initial values in the form
     * @type {object}
     */
    const initialValues = useMemo(() => ({
        [formKeys.startDate]: filters?.startDate ? DateUtils.serverToUTC(filters?.startDate) : undefined,
        [formKeys.endDate]: filters?.endDate ? DateUtils.serverToUTC(filters?.endDate) : undefined,
        [formKeys.keyword]: filters?.keyword,
    }), [filters]);


    /**
     * Submits the form values and triggers search by changing the query
     * @param values
     */
    const onSubmit = (values) => {
        setFilters({
            ...values,
            [formKeys.startDate]: values[formKeys.startDate] ? DateUtils.UTCToServer(values[formKeys.startDate]).format(DateUtils.withoutOffsetFormat) : undefined,
            [formKeys.endDate]: values[formKeys.endDate] ? DateUtils.UTCToServer(values[formKeys.endDate]).format(DateUtils.withoutOffsetFormat) : undefined,
        });
    }

    return (
        <Form
            onSubmit={onSubmit}
            validate={validate}
            initialValues={initialValues}
            render={({submitting, values, form}) => {
                const colClassName = 'px-2 mb-3';
                return (
                    <Row className='no-gutters align-items-center justify-content-center mt-4'>
                        <Col xs={12} className={colClassName}>
                            <InputForm
                                onChange={(val) => form.change('keyword', val)}
                                value={values[formKeys.keyword] ?? ''}
                                label={'Keywords'}
                                name={formKeys.keyword}
                                type={'text'}
                                required={required[formKeys.keyword]}
                            />
                        </Col>
                        <Col xs={6} className={colClassName}>
                            <DatePickerForm
                                name={formKeys.startDate}
                                label={'Start Date'}
                                required={required[formKeys.startDate]}
                                maxDate={values[formKeys.endDate]}
                                disableFuture
                            />
                        </Col>
                        <Col xs={6} className={colClassName}>
                            <DatePickerForm
                                name={formKeys.endDate}
                                label={'End Date'}
                                required={required[formKeys.endDate]}
                                minDate={values[formKeys.startDate]}
                                disableFuture
                            />
                        </Col>
                        <Col xs={12}
                             className='px-3 mt-2 align-items-center row no-gutters justify-content-center align-items-center'>
                            <Button
                                disabled={!!submitting}
                                type={'submit'}
                                variant={'contained'}
                                color={'primary'}
                                className='py-3 px-8'
                            >
                                Search
                            </Button>
                        </Col>
                    </Row>
                );
            }}
        />
    );
}

export default PromotionsListSearchSection;
